export default "__VITE_ASSET__BGEeUryx__"